import {OrderContentData} from "./orderContentData";
/**
 * Created by alex.y on 10/3/2017.
 */
export class OrderContent {
    public Id: any;
    public OrderId: number;
    public OrderStatus: number;
    public Data: OrderContentData = new OrderContentData();
    public Created: Date;
    public Updated: Date;

    public constructor(obj?: Partial<OrderContent>){
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/orders/orderContent.ts